<div class="card flex flex-col gap-6 {{ widthClass() }}">
    <div class="flex items-center justify-between gap-2">
        <div class="font-semibold text-xl">{{ title() }}</div>
        <div class="flex items-center gap-2">
            @if (dirty()) {
            <p-button
                label="Reset all"
                icon="pi pi-undo"
                severity="secondary"
                outlined
                size="small"
                (click)="reset.emit()"
            />
            } @if (importable() && overridden()) {
            <p-button
                label="Fill from…"
                icon="pi pi-download"
                severity="secondary"
                outlined
                size="small"
                (click)="importFrom.emit()"
            />
            }
        </div>
    </div>

    <div class="flex items-center gap-3">
        <p-checkbox
            inputId="override-toggle-{{ title() }}"
            [binary]="true"
            [ngModel]="overridden()"
            (ngModelChange)="overridden.set($event)"
        />
        <label [attr.for]="'override-toggle-' + title()"
            >Override category default</label
        >
        @if (!overridden()) {
        <p-tag severity="info" [value]="'Inherited from ' + sourceText()" />
        }
    </div>

    <ng-content />
</div>
